//ADD TRAINING
export const ADD_TRAINING_REQUEST = "ADD_TRAINING_REQUEST";
export const ADD_TRAINING_SUCCESS = "ADD_TRAINING_SUCCESS";
export const ADD_TRAINING_FAIL = "ADD_TRAINING_FAIL";

//GET TRAINING
export const GET_TRAINING_REQUEST = "GET_TRAINING_REQUEST";
export const GET_TRAINING_SUCCESS = "GET_TRAINING_SUCCESS";
export const GET_TRAINING_FAIL = "GET_TRAINING_FAIL";

//DELETE TRAINING
export const DELETE_TRAINING_REQUEST = "DELETE_TRAINING_REQUEST";
export const DELETE_TRAINING_SUCCESS = "DELETE_TRAINING_SUCCESS";
export const DELETE_TRAINING_FAIL = "DELETE_TRAINING_FAIL";

//GET SPECIFIC TRAINING
export const GET_SPECIFIC_TRAINING_REQUEST = "GET_SPECIFIC_TRAINING_REQUEST";
export const GET_SPECIFIC_TRAINING_SUCCESS = "GET_SPECIFIC_TRAINING_SUCCESS";
export const GET_SPECIFIC_TRAINING_FAIL = "GET_SPECIFIC_TRAINING_FAIL";

//ADD USER_IN_TRAINING
export const ADD_USER_IN_TRAINING_REQUEST = "ADD_USER_IN_TRAINING_REQUEST";
export const ADD_USER_IN_TRAINING_SUCCESS = "ADD_USER_IN_TRAINING_SUCCESS";
export const ADD_USER_IN_TRAINING_FAIL = "ADD_USER_IN_TRAINING_FAIL";

//ADD DEPARTMENT_IN_TRAINING
export const ADD_DEPARTMENT_IN_TRAINING_REQUEST =
  "ADD_DEPARTMENT_IN_TRAINING_REQUEST";
export const ADD_DEPARTMENT_IN_TRAINING_SUCCESS =
  "ADD_DEPARTMENT_IN_TRAINING_SUCCESS";
export const ADD_DEPARTMENT_IN_TRAINING_FAIL =
  "ADD_DEPARTMENT_IN_TRAINING_TRAINING_FAIL";

//ADD MODULE_IN_TRAINING
export const ADD_MODULE_IN_TRAINING_REQUEST = "ADD_MODULE_IN_TRAINING_REQUEST";
export const ADD_MODULE_IN_TRAINING_SUCCESS = "ADD_MODULE_IN_TRAINING_SUCCESS";
export const ADD_MODULE_IN_TRAINING_FAIL =
  "ADD_MODULE_IN_TRAINING_TRAINING_FAIL";

//ADD SECTION_IN_TRAINING
export const ADD_SECTION_IN_TRAINING_REQUEST =
  "ADD_SECTION_IN_TRAINING_REQUEST";
export const ADD_SECTION_IN_TRAINING_SUCCESS =
  "ADD_SECTION_IN_TRAINING_SUCCESS";
export const ADD_SECTION_IN_TRAINING_FAIL =
  "ADD_SECTION_IN_TRAINING_TRAINING_FAIL";

//ADD QUIZ_IN_TRAINING
export const ADD_QUIZ_IN_TRAINING_REQUEST = "ADD_QUIZ_IN_TRAINING_REQUEST";
export const ADD_QUIZ_IN_TRAINING_SUCCESS = "ADD_QUIZ_IN_TRAINING_SUCCESS";
export const ADD_QUIZ_IN_TRAINING_FAIL = "ADD_QUIZ_IN_TRAINING_TRAINING_FAIL";

//EDIT QUIZ_IN_TRAINING
export const EDIT_QUIZ_IN_TRAINING_REQUEST = "EDIT_QUIZ_IN_TRAINING_REQUEST";
export const EDIT_QUIZ_IN_TRAINING_SUCCESS = "EDIT_QUIZ_IN_TRAINING_SUCCESS";
export const EDIT_QUIZ_IN_TRAINING_FAIL = "EDIT_QUIZ_IN_TRAINING_TRAINING_FAIL";

//UPDATE QUIZ_NAME_IN_TRAINING
export const UPDATE_QUIZ_NAME_IN_TRAINING_REQUEST =
  "UPDATE_QUIZ_NAME_IN_TRAINING_REQUEST";
export const UPDATE_QUIZ_NAME_IN_TRAINING_SUCCESS =
  "UPDATE_QUIZ_NAME_IN_TRAINING_SUCCESS";
export const UPDATE_QUIZ_NAME_IN_TRAINING_FAIL =
  "UPDATE_QUIZ_NAME_IN_TRAINING_TRAINING_FAIL";
